import React from "react";
import { useTranslation } from "react-i18next";
import ReactSwitch from "react-switch";

import BannerImages from "../../../Common/BannerImages";
import { SWITCH_PROPS } from "../constants";

interface Props {
    basePath: string[];
    bannerEnabled: boolean;
    mainColor: string;
    updatePath: (path: string[], value: any) => void;
}

export function BannerSection({
    basePath,
    bannerEnabled,
    mainColor,
    updatePath,
}: Props) {
    const { t } = useTranslation();

    return (
        <div
            data-testid="banner-section"
            style={{
                marginBottom: 24,
                padding: 16,
                border: "1px solid #e0e0e0",
                borderRadius: 8,
            }}
        >
            <div className="d-flex align-items-center justify-content-between mb-3">
                <h6
                    style={{
                        fontWeight: 700,
                        fontSize: 15,
                        margin: 0,
                        color: mainColor,
                        textTransform: "uppercase",
                    }}
                >
                    {t("Banner")}
                </h6>
                <ReactSwitch
                    data-testid="banner-enable-switch"
                    {...SWITCH_PROPS}
                    checked={bannerEnabled}
                    onChange={() =>
                        updatePath(
                            [...basePath, "Banner", "Activer"],
                            !bannerEnabled
                        )
                    }
                />
            </div>

            <div className="d-flex flex-column gap-2">
                <BannerImages
                    dataPath={[...basePath, "Banner", "Desktop"]}
                    title="Banner Desktop"
                    size="1920*550 (png, jpg, jpeg)"
                    data-testid="banner-desktop-upload"
                />
                <BannerImages
                    dataPath={[...basePath, "Banner", "Mobile"]}
                    title="Banner Mobile"
                    size="480*410 (png, jpg, jpeg)"
                    data-testid="banner-mobile-upload"
                />
            </div>
        </div>
    );
}
